import { Icon } from '@chakra-ui/react';

export default function SlackFilledIcon(props) {
  return (
    <Icon
      boxSize={5}
      viewBox='0 0 20 20'
      fill='#FEFFFF'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.6665 11.9476C6.6665 11.0738 7.32724 10.3704 8.14798 10.3704C8.96873 10.3704 9.62947 11.0738 9.62947 11.9476V15.8301C9.62947 16.7039 8.96873 17.4074 8.14798 17.4074C7.32724 17.4074 6.6665 16.7039 6.6665 15.8301V11.9476Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9474 13.3333C11.0736 13.3333 10.3701 12.6726 10.3701 11.8518C10.3701 11.0311 11.0736 10.3704 11.9474 10.3704H15.8299C16.7037 10.3704 17.4072 11.0311 17.4072 11.8518C17.4072 12.6726 16.7037 13.3333 15.8299 13.3333H11.9474Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.3701 4.16979C10.3701 3.29599 11.0309 2.59253 11.8516 2.59253C12.6723 2.59253 13.3331 3.29599 13.3331 4.16979V8.05229C13.3331 8.9261 12.6723 9.62956 11.8516 9.62956C11.0309 9.62956 10.3701 8.9261 10.3701 8.05229V4.16979Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.17003 9.62959C3.29624 9.62959 2.59277 8.96885 2.59277 8.14811C2.59277 7.32737 3.29624 6.66663 4.17003 6.66663H8.05253C8.92635 6.66663 9.62981 7.32737 9.62981 8.14811C9.62981 8.96885 8.92635 9.62959 8.05253 9.62959H4.17003Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.3701 15.9259C10.3697 16.1206 10.4077 16.3134 10.482 16.4934C10.5564 16.6733 10.6655 16.8368 10.8031 16.9744C10.9408 17.1121 11.1042 17.2212 11.2842 17.2955C11.4641 17.3698 11.6569 17.4078 11.8516 17.4074C12.6723 17.4074 13.3331 16.7467 13.3331 15.9259C13.3335 15.7313 13.2955 15.5384 13.2212 15.3585C13.1469 15.1786 13.0377 15.0151 12.9001 14.8775C12.7624 14.7398 12.599 14.6307 12.419 14.5564C12.2391 14.4821 12.0463 14.444 11.8516 14.4445H10.3701V15.9259Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.9258 9.62959H14.4443V8.14811C14.4443 7.32737 15.1051 6.66663 15.9258 6.66663C16.7466 6.66663 17.4073 7.32737 17.4073 8.14811C17.4073 8.96885 16.7466 9.62959 15.9258 9.62959Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.07426 10.3704H5.55574V11.8518C5.55574 12.6726 4.895 13.3333 4.07426 13.3333C3.87959 13.3337 3.68676 13.2957 3.50683 13.2214C3.3269 13.1471 3.16342 13.038 3.02577 12.9003C2.88812 12.7627 2.77901 12.5992 2.7047 12.4193C2.6304 12.2393 2.59236 12.0465 2.59278 11.8518C2.59278 11.0311 3.25352 10.3704 4.07426 10.3704Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.62947 4.07414V5.55562H8.14799C7.95332 5.55603 7.76049 5.518 7.58056 5.44369C7.40063 5.36939 7.23715 5.26028 7.0995 5.12263C6.96185 4.98498 6.85274 4.82149 6.77843 4.64156C6.70413 4.46164 6.66609 4.2688 6.66651 4.07414C6.66651 3.2534 7.32725 2.59265 8.14799 2.59265C8.34266 2.59224 8.53549 2.63028 8.71542 2.70458C8.89535 2.77888 9.05883 2.88799 9.19648 3.02565C9.33413 3.1633 9.44324 3.32678 9.51754 3.50671C9.59185 3.68664 9.62988 3.87947 9.62947 4.07414Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.296296'
        strokeLinecap='round'
      />
    </Icon>
  );
}
